module.exports = __webpack_public_path__ + "static/media/icon-trial-account.0dbf6ff1.png";